import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { FormService } from '../../../services/form.service';
import { NmDetailPageClass } from '../../../shared/nm-detail-page-class';
import { ApiService } from '../../../services/api.service';

declare let bootbox: any;

@Component({
	selector: 'school-detail-page',
	templateUrl: './detail.html',
	styleUrls: ['./detail.css']
})
export class SchoolsDetailPage extends NmDetailPageClass {
	public header: string;
	public modelName: string = 'school';

	public reloadTable: boolean = false;
	
	public form: FormGroup = this.formBuilder.group({
		// basic information
	  //YFSID: [{value: '', disabled: true}],
	  SchoolId: [{value: '',disabled: true}],
		NameSchool: ['',Validators.required],
		NameChin: [''],
	  status: ['',Validators.required],
	  schoolNature: ['',Validators.required],
		secondaryNatureCode: ['',Validators.required],
		Address1: [''],
		Address2: [''],
		Address3: [''],
		subdistrictId: [''],
		Tel: [''],
		Fax: [''],
		SchoolEmail: [''],
		website: [''],
		schoolInterests: [''],
		receiveInformationIn: ['',Validators.required],
		receiveInformationVia: ['',Validators.required],
		remarks: [''],
		
	});

	public onBeforeRendered() {
		/*let control = <FormArray>this.form.get('_contact_channels');
		for(let channel of this.data.shared.communicationChannels.getValue()) {
			control.push(this.formBuilder.control(false));
		}*/

		let map = {
			create: 'Schools <small><i class="ace-icon fa fa-angle-double-right"></i></small> New School',
			edit: 'Schools <small><i class="ace-icon fa fa-angle-double-right"></i></small> Edit School',
			view: 'Schools <small><i class="ace-icon fa fa-angle-double-right"></i></small> View School',
		};
		this.header = map[this.action];

		// TODO: dummy way to fix missing fields
		if(this.action != 'create') {
			//this.form.removeControl('id_document_number');
		}
	}

	public onBeforeSubmit(data) {
		
		this._form.setForm(this.form);

		
		 //console.log(data);
		 //return false;
		return data;
	}

	public onBeforePatchValue(data: any): any {
		return new Promise(resolve => {
			
			//hkaf
			let interestArr: string[] = [];
			for(let it of data.interest){
				interestArr.push(it.Id as string);
			}
			data.schoolInterests = interestArr;
			//console.log(data.schoolInterests);
			resolve(data);

			// Promise.all([
			// 	data.home_address && data.home_address.region_id? this.data.shared.getRegionHierarchyById(data.home_address.region_id): [],
			// 	data.office_address && data.office_address.region_id? this.data.shared.getRegionHierarchyById(data.office_address.region_id): []
			// ]).then(values => {
			// 	data._home_region_id = values[0].map(v => v.id);
			// 	data._office_region_id = values[1].map(v => v.id);
			// 	console.log(data);

			// 	resolve(data);
			// });
		});
	}


}


// WEBPACK FOOTER //
// ./src/pages/schools/detail/detail.ts